angular.module("vendor")
.directive("onlyDigits", function() {
    return {
        require: "ngModel",
        restrict: "A",
        link: function(scope, element, attr, ctrl) {
            function inputValue(val) {
                if (val) {
                    var digits = val.replace(/[^0-9]/g, "");

                    if (digits !== val) {
                        ctrl.$setViewValue(digits);
                        ctrl.$render();
                    }
                    return digits;
                }
                return "";
            }

            ctrl.$parsers.push(inputValue);
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/only-digits/only-digits.directive.js
// module id = 804
// module chunks = 0